export class Codeword{
    code: string;
    tp: string;
    exp_date: string;
    ix: number;

    constructor(tp: string, ix: number){
        this.tp = tp;
        this.ix = ix;
        this.exp_date = '';
    }
}